import { differenceInDays, differenceInHours } from "date-fns";

import {
  SeismicEventAgeColors,
  SeismicEventDepthColors,
  SeismicEventPropertyOptions,
} from "@/features/shared/widgets/map/map.types";

const getSeismicColors = (
  property: SeismicEventPropertyOptions,
  time: string,
  depth: number,
) => {
  let backgroundColor: SeismicEventAgeColors | SeismicEventDepthColors =
    SeismicEventAgeColors.MONTHS;
  if (property === SeismicEventPropertyOptions.AGE) {
    const [nowDate, markerDate] = [new Date(), new Date(time)];
    if (differenceInHours(nowDate, markerDate) < 24) {
      backgroundColor = SeismicEventAgeColors.HOURS;
    } else if (differenceInDays(nowDate, markerDate) < 7) {
      backgroundColor = SeismicEventAgeColors.DAYS;
    } else if (differenceInDays(nowDate, markerDate) <= 30) {
      backgroundColor = SeismicEventAgeColors.WEEKS;
    } else {
      backgroundColor = SeismicEventAgeColors.MONTHS;
    }
  } else if (property === SeismicEventPropertyOptions.DEPTH) {
    if (depth <= 15) {
      backgroundColor = SeismicEventDepthColors.LEVEL_1;
    } else if (depth <= 35) {
      backgroundColor = SeismicEventDepthColors.LEVEL_2;
    } else if (depth <= 70) {
      backgroundColor = SeismicEventDepthColors.LEVEL_3;
    } else if (depth <= 150) {
      backgroundColor = SeismicEventDepthColors.LEVEL_4;
    } else {
      backgroundColor = SeismicEventDepthColors.LEVEL_5;
    }
  }

  return backgroundColor;
};

export default getSeismicColors;
